import { styled } from '@mui/system'
import { Box } from '@mui/material'

const shouldForwardProp = (prop) => !['ignoreBeforeContentSpace', 'ignoreAfterContentSpace'].includes(prop)

export const Root = styled(Box, { shouldForwardProp })`
	min-height: 100%;
	width: 100%;
	position: relative;
	display: grid;
	grid-template-rows: ${({ ignoreBeforeContentSpace, ignoreAfterContentSpace }) => {
		if (ignoreBeforeContentSpace && ignoreAfterContentSpace) {
			return '1fr'
		} else if (ignoreBeforeContentSpace) {
			return '1fr auto'
		} else if (ignoreAfterContentSpace) {
			return 'auto 1fr'
		} else {
			return 'auto 1fr auto'
		}
	}};
	grid-template-columns: 100%;
`
